'use client';

import React, { useState, useEffect } from 'react';
import OptimizedImage from './OptimizedImage';
import { ChevronRightIcon } from './Icons';

const images = [
    {
        src: '/images/products/etsy_listing_hero.jpg',
        alt: 'The Ultimate 3-in-1 Bakery Bundle'
    },
    {
        src: '/images/products/etsy_listing_how_it_works.jpg',
        alt: 'Built to Make Pricing Effortless'
    },
    {
        src: '/images/products/etsy_listing_offline.jpg',
        alt: 'Desktop Power + Advanced Features'
    },
    {
        src: '/images/products/etsy_listing_whats_included.jpg',
        alt: 'What\'s Included in the Bundle'
    },
    {
        src: '/images/products/etsy_listing_why_choose.jpg',
        alt: 'Why Choose Bakery Pro'
    }
];

export const BundleCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000); 
        return () => clearInterval(interval);
    }, []);

    const goToNext = () => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };

    const goToPrev = () => {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    return (
        <div className="relative z-10 w-full aspect-square md:aspect-video bg-[#fdfaf6] rounded-[2rem] shadow-2xl border border-stone-100 overflow-hidden group">
            {images.map((image, index) => (
                <div
                    key={index}
                    className={`absolute top-0 left-0 w-full h-full transition-opacity duration-700 ${
                        index === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
                    }`}
                >
                    <OptimizedImage
                        src={image.src}
                        alt={image.alt}
                        fill
                        containerClassName="w-full h-full"
                        className="object-contain w-full h-full p-4"
                    />
                </div>
            ))}
            
            {/* Navigation Arrows */}
            <button 
                onClick={goToPrev}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/90 hover:bg-white text-brand-pink p-3 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity"
                aria-label="Previous image"
            >
                <ChevronRightIcon className="w-6 h-6 rotate-180" />
            </button>
            <button 
                onClick={goToNext}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/90 hover:bg-white text-brand-pink p-3 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity"
                aria-label="Next image"
            >
                <ChevronRightIcon className="w-6 h-6" />
            </button>

            {/* Pagination Dots */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-3">
                {images.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentIndex(index)}
                        className={`w-3 h-3 rounded-full transition-all ${
                            index === currentIndex ? 'bg-brand-pink scale-125' : 'bg-stone-300 hover:bg-brand-pink/50'
                        }`}
                        aria-label={`Go to image ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};
